import {convertRemToPixels} from '~/common/utils';

export const getEcardIdFromURL = () => window.location.pathname.split('/')[2];

/**
 *
 * @param element The text element whose text is being resized
 * @param initialFontSize The initial font size
 * @param units The units of the font size
 */
/* eslint-disable no-param-reassign */
export const resizeText = (
  element: HTMLElement,
  initialFontSize = 16,
  units: 'rem' | 'px' = 'px'
) => {
  let fontSize = initialFontSize;
  if (units === 'rem') {
    fontSize = convertRemToPixels(initialFontSize);
  }
  element.style.fontSize = `${fontSize}px`;

  // Check if the text overflows the container
  while (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth) {
    fontSize--; // Decrease font size
    element.style.fontSize = `${fontSize}px`;

    // Stop if font size is too small
    if (fontSize <= 8) {
      break;
    }
  }
};
/* eslint-enable no-param-reassign */
